/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2DragHandleIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2DragHandleIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2DragHandleIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 8,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2DragHandleIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 8 12"
 style={{'--as-1-Z1El9Og': alignSelf,'--mt-2-Z1El9Og': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1El9Og': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1El9Og': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1El9Og': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1El9Og': opacity,'--w-10-Z1El9Og': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1El9Og': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1El9Og': fill,'--a-7-Z1El9Og': isAnimated ? animation : "none",'--sd-8-Z1El9Og': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1El9Og': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2DragHandleIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2 3.429A1.714 1.714 0 102 0a1.714 1.714 0 000 3.429zm0 4.285a1.714 1.714 0 100-3.428 1.714 1.714 0 000 3.428zm1.714 2.572a1.714 1.714 0 11-3.428 0 1.714 1.714 0 013.428 0zm2.572-6.857a1.714 1.714 0 100-3.429 1.714 1.714 0 000 3.429zM8 6A1.714 1.714 0 114.57 6 1.714 1.714 0 018 6zm-1.714 6a1.714 1.714 0 100-3.429 1.714 1.714 0 000 3.429z"
 style={{'--f-12-Z1El9Og': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}